//请自行添加语言资源
const dashboard = {
  msg:{
  }
};
export default dashboard



// WEBPACK FOOTER //
// ./src/page/report/dashboard/lang/dashboard.zh.js